module.exports = {"632857100":"柴旦镇","632857101":"锡铁山镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/632857.json
// module id = 3164
// module chunks = 0